export const LOGIN_URL = '/z/auth/api/login';
export const LOGOUT_URL = '/z/auth/api/logout';
export const GUEST_TOKEN_URL = '/z/auth/api/guest';
export const SESSION_URL = '/z/auth/api/session';
export const PROFILE_URL = '/z/auth/api/me';
